import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import classNames from 'classnames';

import { Mail, MailChunky } from '@eb/eds-iconography';

import NotificationScreen from '../NotificationScreen';

const ForgotPasswordEmailStatus = ({ email, usesNewStyles }) => {
    const headerText = gettext('Check your email');
    const componentClasses = classNames('eds-l-mar-vert-14', {
        'reset-password-status-page': usesNewStyles,
    });
    let iconProps = {
        iconType: <Mail />,
    };
    let subtitleText = gettext(
        'We sent you an email with instructions to reset your password.',
    );

    if (usesNewStyles) {
        iconProps = {
            iconColor: 'ui-700',
            iconType: <MailChunky />,
        };
    }

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.
    if (email) {
        subtitleText = gettext(
            'We sent an email to %(email)s with instructions to reset your password.',
            { email },
        );
    }

    return (
        <div className={componentClasses}>
            <NotificationScreen
                {...iconProps}
                headerText={headerText}
                subtitleText={subtitleText}
                usesNewStyles={usesNewStyles}
            />
        </div>
    );
};

ForgotPasswordEmailStatus.propTypes = {
    email: PropTypes.string,
    usesNewStyles: PropTypes.bool,
};

export default ForgotPasswordEmailStatus;
